export function getGridTemplate(length, cellSize) {
  return `repeat(${length}, ${cellSize}px)`
}
